var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseFloodElevation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1212,
    height: 846,
    viewBox: "0 0 1212 846",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3192_127)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456 656L456 416L432 416L432 656L456 656Z",
    fill: "#324755"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M761 656L761 416L737 416L737 656L761 656Z",
    fill: "#324755"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3192_127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -71,
    width: 1930,
    height: 917
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1930 -71H0V846H1930V-71Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3192_127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M1930 -71H0V846H1930V-71Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "water",
    d: "M1212 577H0V778H1212V577Z",
    fill: "#87BDC0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M288.871 778H901.871C901.871 778 787.024 766.87 636.73 639.089C528.3 546.903 399.983 585.115 360.878 604.968C333.066 619.086 308.034 629.433 288.871 636.442V778Z",
    fill: "#C9D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M288.871 778H595.871C593.301 773.148 559.616 772.618 531.308 750.85C420.341 665.527 357.777 657.234 288.871 663.727V778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M889.871 778H350.871C350.871 778 451.856 766.87 584.002 639.089C679.341 546.903 792.17 585.115 826.55 604.968C851.005 619.086 873.015 629.433 889.867 636.442V778H889.871Z",
    fill: "#C9D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M894.6 778.59H265C270.27 773.74 339.35 773.21 397.41 751.45C624.98 666.16 753.29 657.87 894.6 664.36V778.59Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.852 511.65H631.452V453.13L596.492 435.55L561.472 455.74V511.51H538.082V442.22L595.732 408.98L654.852 438.7V511.65Z",
    fill: "#314755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.791 513.79H684.401V411.97L596.091 367.57L508.531 418.06V513.49H485.141V404.54L595.331 341L707.791 397.55V513.79Z",
    fill: "#314755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.711 514.25H737.321V376.55L595.691 305.34L455.611 386.11V513.79H432.211V372.6L594.931 278.77L760.711 362.13V514.25Z",
    fill: "#324755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.711 511.29H432.211V535.33H760.711V511.29Z",
    fill: "#324755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "home_base_and_sides"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456 602L456 423L432 423L432 602L456 602Z",
    fill: "#324755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761 602L761 423L737 423L737 602L761 602Z",
    fill: "#324755"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "home_static_posts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456 656L456 389L432 389L432 656L456 656Z",
    fill: "#324755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761 656L761 389L737 389L737 656L761 656Z",
    fill: "#324755"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1212 654H0V779H1212V654Z",
    fill: "#B9B0A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top_line",
    d: "M0 578H1212",
    stroke: "#324755",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "first_floor_elevation",
    d: "M760 579H889",
    stroke: "#324755",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.582 578.55H895.082",
    stroke: "#324755",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.98 476.62H433.48",
    stroke: "#324755",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.582 546.62H895.082",
    stroke: "#324755",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "freeboard_pointer_line",
    d: "M860 538H800",
    stroke: "#334755",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "freeboard_pointer_head",
    d: "M778 538L802 526V550L778 538Z",
    fill: "#334755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.449 577.68H265.239",
    stroke: "#334755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.68 577.68L263.33 562.47V592.87L279.68 577.68Z",
    fill: "#334755"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3192_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1212,
    height: 846,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseFloodElevation);
export default __webpack_public_path__ + "static/media/base_flood_elevation.38d96c829f3b8298d08977349af07a3d.svg";
export { ForwardRef as ReactComponent };